<div class="button-leitor-side-menu-container">
  <div class="button-leitor-side-menu" [style.color]="opcao.cor">
    <mat-icon
      class="custom-button-leitor-side-menu-icon button-leitor-side-menu-icon {{
        opcao.icone
      }}"
      svgIcon="{{ opcao.icone }}"
      (click)="selectionOpcaoToolbar()"
    ></mat-icon>
  </div>
</div>
